import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import bannerRules from './priority-banner.config.json';
import { BannerContent, PriorityBannerRule, ProductsQualifyResponse } from './priority-banner.model';
import { HttpErrorResponse } from '@angular/common/http';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ProductCallbackService } from 'src/app/services/product-callback.service';
import { GeminiSessionService } from 'src/app/services/gemini-session.service';
import { SapiService } from 'src/app/services/sapiservice.service';
import { CommonModule } from '@angular/common';

// Sorted so priority 1 comes first
const BANNER_RULES: PriorityBannerRule[] = [...bannerRules].sort((a, b) => a.priority - b.priority);

@Component({
  selector: 'app-priority-top-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './priority-top-banner.component.html',
  styleUrl: './priority-top-banner.component.css'
})
export class PriorityTopBannerComponent {
  /** Null when no configured priority matches, which hides the banner. */
  banner: BannerContent | null = null;

  /** The products-qualify API response. */
  @Input() productsQualifyResponse: ProductsQualifyResponse | null | undefined;

  @Input() pageName: string = '';

  @ViewChild('callbackErrorModel', { static: false }) callbackErrorModel!: TemplateRef<any>;

  modalOptions: NgbModalOptions = {
    backdrop: 'static',
    backdropClass: 'customBackdrop',
    keyboard: false
  };
  callBackErrorDebt: string = '';
  totalOpenAccount: number = 0;
  creditReportBalance: number = 0;
  myCreditScore: number = 0;



  constructor(
    private productCallbackService: ProductCallbackService,
    private modalService: NgbModal,
    private geminiSessionService: GeminiSessionService,
    private sapiService: SapiService,
  ) {

  }

  /** Returns the banner for the highest priority the API returned, or null (banner hidden) if nothing matches. */
  private getPriorityBanner(response: ProductsQualifyResponse | null | undefined): BannerContent | null {
    if (!response) {
      return null;
    }

    // Rules are checked from priority 1 upwards, so the first match is the highest priority.
    for (const rule of BANNER_RULES) {
      for (const source of rule.sources) {
        // e.g. the priority 1 rule matches when response.dcResponse.priority === 1
        if (response[source]?.priority === rule.priority) {
          return { ...rule.banner, ...rule.pageOverrides?.[this.pageName] };
        }
      }
    }

    return null;
  }

  // Recomputed on any input change so it doesn't matter whether pageName or the response arrives first.
  ngOnChanges(): void {
    this.banner = this.getPriorityBanner(this.productsQualifyResponse);
  }

  ngOnInit(): void {
    this.getCreditHelthInfoData();
  }

  getCreditHelthInfoData() {
    const stored = sessionStorage.getItem('loadCreditHealthInfo');
    const info = stored ? JSON.parse(stored)?.creditHealthInfo : null;
    if (!info) {
      return;
    }

    const loanCountKeys = [
      'homeLoanAccountCount',
      'carLoanAccountCount',
      'retailerLoanAccountCount',
      'creditLoanAccountCount',
      'personalLoanAccountCount',
    ];

    this.totalOpenAccount = loanCountKeys.reduce((sum, key) => sum + (Number(info[key]) || 0), 0);
    this.creditReportBalance = info.totalCurrentBalance ?? 0;

    const creditScoreData = sessionStorage.getItem('load');
    const scoreData = creditScoreData ? JSON.parse(creditScoreData) : null;
    if (!scoreData) {
      return;
    }

    this.myCreditScore = Number(scoreData.creditHistory?.scoreInformation?.score) || 0;
  }

  handleBannerCta(priority: any, buttonId: string) {
    console.log("priority", priority, buttonId)
    if (priority == 1) {
      this.omniLeadCreate(buttonId, 'Online')
    } else if (priority == 2) {
      this.spltransferLead();
    } else if (priority == 3) {
      this.CreateSapiVisit();
    }

  }


  //omni call
  omniLeadCreate(campaignSource: string, webSource: string) {
    this.productCallbackService.omniCallback(campaignSource, webSource).subscribe({
      next: (data: any) => {
        if (data.statusCode == 302 && data.returnUrl != '') {
          window.location.href = data.returnUrl;
        }
        else {
          this.callBackErrorDebt = 'Something went wrong. Please try again later';
          this.modalService.dismissAll();
          this.modalService.open(this.callbackErrorModel, this.modalOptions);
        }
      }, error: (err: HttpErrorResponse) => {
        this.callBackErrorDebt = 'Something went wrong. Please try again later';
        this.modalService.dismissAll();
        this.modalService.open(this.callbackErrorModel, this.modalOptions);
      }
    });
  }

  // tymx
  spltransferLead() {
    this.productCallbackService.sanlamLead().subscribe({
      next: (data: any) => {
        if (data?.responseCode === '200') {
          this.geminiSessionService.handleExternalNavigation(data.redirectUrl);
        }
      }, error: (err: HttpErrorResponse) => {
        console.error(err.message)
      }
    });
  }

  //SAPI redirect
  CreateSapiVisit(){
    this.sapiService.createSapiVisit().subscribe({
      next: (data: any) => {
          this.geminiSessionService.handleExternalNavigation(data?.returnUrl);
       },
      error: (err: HttpErrorResponse) => {
        console.error('Error creating SAPI visit', err);
      }
    });
  }

}
